import * as types from './types';
import { AssignItemsToSite as FieldEnum } from 'Common/FieldEnum';
import { OrderPreferenceEnum } from 'Common/Constants/Enumeration/OrderPreferenceEnum';
import _ from 'lodash';

const build = (data, selectedColumnName, checkAll, OrderPreferenceId) => {
  if (OrderPreferenceId !== OrderPreferenceEnum.vendorOnly) {
    if (selectedColumnName === FieldEnum.VendorOnly) {
      if (checkAll) {
        data[FieldEnum.VendorOnly] = checkAll;
        data[FieldEnum.VendorOrder] = checkAll;
        data[FieldEnum.CheckBox] = checkAll;
      } else if (!checkAll) {
        data[FieldEnum.VendorOnly] = checkAll;
      }
    } else if (selectedColumnName === FieldEnum.VendorOrder) {
      if (checkAll) {
        data[FieldEnum.VendorOrder] = checkAll;
        data[FieldEnum.CheckBox] = checkAll;
      } else if (!checkAll) {
        data[FieldEnum.VendorOnly] = checkAll;
        data[FieldEnum.VendorOrder] = checkAll;
      }
    } else if (selectedColumnName === FieldEnum.CheckBox) {
      if (checkAll) {
        data[FieldEnum.CheckBox] = checkAll;
      } else if (!checkAll) {
        data[FieldEnum.VendorOnly] = checkAll;
        data[FieldEnum.CheckBox] = checkAll;
        data[FieldEnum.VendorOrder] = checkAll;
      }
    }
  } else if (selectedColumnName === FieldEnum.CheckBox) {
    data[FieldEnum.CheckBox] = checkAll;
  }
  data.dirty = true;
};

const buildIndividual = (data, action) => {
  if (action.payload.OrderPreferenceId !== OrderPreferenceEnum.vendorOnly) {
    if (action.payload.fieldName === FieldEnum.VendorOnly) {
      if (!action.payload.currentRow[action.payload.fieldName]) {
        data[FieldEnum.VendorOnly] = true;
        data[FieldEnum.VendorOrder] = true;
        data[FieldEnum.CheckBox] = true;
      } else if (action.payload.currentRow[action.payload.fieldName]) {
        data[FieldEnum.VendorOnly] = false;
      }
    } else if (action.payload.fieldName === FieldEnum.VendorOrder) {
      if (!action.payload.currentRow[action.payload.fieldName]) {
        data[FieldEnum.VendorOrder] = true;
        data[FieldEnum.CheckBox] = true;
      } else if (action.payload.currentRow[action.payload.fieldName]) {
        data[FieldEnum.VendorOnly] = false;
        data[FieldEnum.VendorOrder] = false;
      }
    } else if (action.payload.fieldName === FieldEnum.CheckBox) {
      if (action.payload.currentRow[action.payload.fieldName]) {
        data[FieldEnum.CheckBox] = false;
        data[FieldEnum.VendorOnly] = false;
        data[FieldEnum.VendorOrder] = false;
      } else if (!action.payload.currentRow[action.payload.fieldName]) {
        data[FieldEnum.CheckBox] = true;
      }
    }
  } else if (action.payload.fieldName === FieldEnum.CheckBox) {
    data[FieldEnum.CheckBox] = !action.payload.currentRow[
      action.payload.fieldName
    ];
  }
  data.dirty = true;
};

const INITIAL_STATE = {
  bidGroupData: [],
  bidGroupDataError: null,
  itemGroupData: [],
  itemGroupDataError: null,
  acctCategoryData: [],
  acctCategoryDataError: null,
  vendorData: [],
  vendorDataError: null,
  storageLocationData: [],
  storageLocationDataError: null,
  assignItemsData: [],
  assignItemsDataError: null,
  saveOrderingItemsError: null,
  loading: false,
  isSubmitting: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SITESETUP_ASSIGN_ORDERING_ITEMS_DATA: {
      const assignItemsData = action.payload.data.Data;
      return {
        ...state,
        assignItemsData,
      };
    }
    case types.SITESETUP_ASSIGN_ITEMS_BIDGROUP: {
      const bidGroupData = action.payload.data.Data;
      return {
        ...state,
        bidGroupData,
      };
    }

    case types.SITESETUP_ASSIGN_ITEMS_ITEMGROUP: {
      const itemGroupData = action.payload.data.Data;
      return {
        ...state,
        itemGroupData,
      };
    }

    case types.SITESETUP_ASSIGN_ITEMS_ACCT_CATEGORY: {
      const acctCategoryData = action.payload.data.Data;
      return {
        ...state,
        acctCategoryData,
      };
    }

    case types.SITESETUP_ASSIGN_ITEMS_VENDOR: {
      const vendorData = action.payload.data.Data;
      return {
        ...state,
        vendorData,
      };
    }

    case types.SITESETUP_ASSIGN_ITEMS_STORAGE_LOCATION: {
      const storageLocationData = action.payload.data.Data;
      return {
        ...state,
        storageLocationData,
      };
    }

    case types.SITESETUP_UPDATE_ASSIGN_ITEMS_DATA:
      let assignItemsDataCopy = JSON.parse(
        JSON.stringify(state.assignItemsData)
      );
      const currentRow = action.payload.currentRow;
      const data = _.find(assignItemsDataCopy, {
        ItemCode: currentRow.ItemCode,
      });
      buildIndividual(data, action);
      return {
        ...state,
        assignItemsData: assignItemsDataCopy,
      };

    case types.SITESETUP_CHECKALL_ASSIGN_ITEMS_DATA:
      let copiedData = JSON.parse(JSON.stringify(state.assignItemsData));
      _.each(copiedData, data => {
        if (Object.keys(action.payload.filterValues).length > 0) {
          let isFilteredData = true;
          _.each(Object.keys(action.payload.filterValues), key => {
            const filteredValues = action.payload.filterValues[key];
            if (data[key] !== filteredValues) {
              isFilteredData = false;
            }
          });
          if (isFilteredData) {
            build(
              data,
              action.payload.columnName,
              action.payload.checkAll,
              action.payload.OrderPreferenceId
            );
          }
        } else {
          build(
            data,
            action.payload.columnName,
            action.payload.checkAll,
            action.payload.OrderPreferenceId
          );
        }
      });
      return {
        ...state,
        assignItemsData: copiedData,
      };
    case types.SITESETUP_ASSIGN_ITEMS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.SITESETUP_ASSIGN_ITEMS_BEGIN_SUBMIT: {
      return {
        ...state,
        isSubmitting: true,
      };
    }
    case types.SITESETUP_ASSIGN_ITEMS_END_SUBMIT: {
      return {
        ...state,
        isSubmitting: false,
      };
    }
    case types.SITESETUP_RESET_ASSIGN_ITEMS_ON_CLOSE: {
      return {
        ...state,
        assignItemsData: [],
        loading: false,
      };
    }
    case types.SITESETUP_RESET_ASSIGN_AND_MODIFIED_ITEMS: {
      return {
        ...state,
        assignItemsData: [],
        loading: false,
      };
    }
    case types.SITESETUP_ASSIGN_ITEMS_BIDGROUP_ERROR:
      const bidGroupResponse = action.payload.response;
      if (
        _.has(
          bidGroupResponse,
          'data.Errors' &&
            bidGroupResponse.data.Errors &&
            bidGroupResponse.data.Errors.length
        )
      ) {
        return {
          ...state,
          bidGroupDataError: bidGroupResponse.data.Errors,
        };
      }
      return {
        ...state,
        bidGroupDataError: {
          Title: 'Error',
          Message:
            'An error occurred while fetching bid groups. Please try again.',
        },
      };

    case types.SITESETUP_ASSIGN_ITEMS_ITEMGROUP_ERROR:
      const itemGroupResponse = action.payload.response;
      if (
        _.has(
          itemGroupResponse,
          'data.Errors' &&
            itemGroupResponse.data.Errors &&
            itemGroupResponse.data.Errors.length
        )
      ) {
        return {
          ...state,
          itemGroupDataError: itemGroupResponse.data.Errors,
        };
      }
      return {
        ...state,
        itemGroupDataError: {
          Title: 'Error',
          Message:
            'An error occurred while fetching item groups. Please try again.',
        },
      };

    case types.SITESETUP_ASSIGN_ITEMS_ACCT_CATEGORY_ERROR:
      const acctCategoryResponse = action.payload.response;
      if (
        _.has(
          acctCategoryResponse,
          'data.Errors' &&
            acctCategoryResponse.data.Errors &&
            acctCategoryResponse.data.Errors.length
        )
      ) {
        return {
          ...state,
          acctCategoryDataError: acctCategoryResponse.data.Errors,
        };
      }
      return {
        ...state,
        acctCategoryDataError: {
          Title: 'Error',
          Message:
            'An error occurred while fetching account categories. Please try again.',
        },
      };

    case types.SITESETUP_ASSIGN_ITEMS_STORAGE_LOCATION_ERROR:
      const storageLocationResponse = action.payload.response;
      if (
        _.has(
          storageLocationResponse,
          'data.Errors' &&
            storageLocationResponse.data.Errors &&
            storageLocationResponse.data.Errors.length
        )
      ) {
        return {
          ...state,
          storageLocationDataError: storageLocationResponse.data.Errors,
        };
      }
      return {
        ...state,
        storageLocationDataError: {
          Title: 'Error',
          Message:
            'An error occurred while fetching storage location. Please try again.',
        },
      };

    case types.SITESETUP_ASSIGN_ITEMS_DATA_ERROR:
      const assignItemsResponse = action.payload.response;
      if (
        _.has(
          assignItemsResponse,
          'data.Errors' &&
            assignItemsResponse.data.Errors &&
            assignItemsResponse.data.Errors.length
        )
      ) {
        return {
          ...state,
          assignItemsDataError: assignItemsResponse.data.Errors,
        };
      }
      return {
        ...state,
        assignItemsDataError: {
          Title: 'Error',
          Message:
            'An error occurred while fetching assign items. Please try again.',
        },
      };

    case types.SITESETUP_ASSIGN_ITEMS_VENDOR_ERROR:
      const vendorResponse = action.payload.response;
      if (
        _.has(
          vendorResponse,
          'data.Errors' &&
            vendorResponse.data.Errors &&
            vendorResponse.data.Errors.length
        )
      ) {
        return {
          ...state,
          vendorDataError: vendorResponse.data.Errors,
        };
      }
      return {
        ...state,
        vendorDataError: {
          Title: 'Error',
          Message:
            'An error occurred while fetching distributors. Please try again.',
        },
      };

    case types.SITESETUP_SAVE_ORDERING_ITEMS_ERROR:
      const saveOrderingItemsResponse = action.payload.response;
      if (
        _.has(
          saveOrderingItemsResponse,
          'data.Errors' &&
            saveOrderingItemsResponse.data.Errors &&
            saveOrderingItemsResponse.data.Errors.length
        )
      ) {
        return {
          ...state,
          saveOrderingItemsError: saveOrderingItemsResponse.data.Errors,
        };
      }
      return {
        ...state,
        saveOrderingItemsError: {
          Title: 'Error',
          Message: 'An error occurred while assigning items',
        },
      };
    case types.SITESETUP_CLEAR_ASSIGN_ITEMS_ERROR_SUCCESS:
      return {
        ...state,
        saveOrderingItemsError: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/assignItems/reducer.js